var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "video-container"
  }, [_c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "video-con"
  }, _vm._l(_vm.cubList, function (item) {
    return _c("div", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("video", item.threadId);
        }
      }
    }, [_c("video", {
      attrs: {
        controls: "",
        src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
      }
    })]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };